<div class="item">
  <span class="thin">Adserver</span>
  <ad-server-status-badge [adServerStatus]="adServerStatus"></ad-server-status-badge>
</div>
